import React from 'react';

import { basePageWrap } from '../BasePage/index';
import s from './ListOverviewPage.module.css';
import ContentBlocks from '../../components/blocks/ContentBlocks';
import ListItem from '@/components/ListItem';

import { ListOverviewPageProps } from '@/types/containers/listOverviewPage';

const ListOverviewPage = ({
    content,
    childListItems,
}: ListOverviewPageProps) => {
    const sortedChildListItems = childListItems.slice().sort((a, b) => {
        return (
            new Date(b.lastPublishedAt).getTime() -
            new Date(a.lastPublishedAt).getTime()
        );
    });

    return (
        <>
            <div className={s['ListOverviewPage']}>
                <ContentBlocks content={content} />
                <ul className="wb-container">
                    {sortedChildListItems.map((item, index) => (
                        <ListItem key={index} {...item} />
                    ))}
                </ul>
            </div>
        </>
    );
};

export default basePageWrap(ListOverviewPage);
